define("shared/models/ig-user", ["exports", "@ember/object"], function (_exports, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class;

  0; //eaimeta@70e063a35619d71f0,"@ember/object"eaimeta@70e063a35619d71f

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  let IgUser = (_dec = (0, _object.computed)('profilePictureUrl'), (_class = class IgUser extends _object.default {
    constructor() {
      super(...arguments);

      _defineProperty(this, "id", undefined);

      _defineProperty(this, "accountType", null);

      _defineProperty(this, "bio", null);

      _defineProperty(this, "followsCount", 0);

      _defineProperty(this, "followedByCount", 0);

      _defineProperty(this, "fullName", null);

      _defineProperty(this, "isPlaceholderProfilePicture", false);

      _defineProperty(this, "mediaCount", 0);

      _defineProperty(this, "profilePictureUrl", null);

      _defineProperty(this, "socialProfile", null);

      _defineProperty(this, "username", null);

      _defineProperty(this, "website", null);
    }

    get secureProfilePictureUrl() {
      if (this.profilePictureUrl) {
        return this.profilePictureUrl.replace('http://', 'https://');
      }

      return null;
    }

  }, (_applyDecoratedDescriptor(_class.prototype, "secureProfilePictureUrl", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "secureProfilePictureUrl"), _class.prototype)), _class));
  _exports.default = IgUser;
});